/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 25/5/2023
 */

import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import SidePanel from "../Components/SidePanel/SidePanel";
import SignUpDialog from "../Components/Auth/SignUpDialog";
import SigninDialog from "../Components/Auth/SignInDialog";
import NavBar from "../Components/NavBar/NavBar";
import styles from "./MainLayout.module.css";

const MainLayout = ({ themeMode, onThemeToggle }) => {
  const [isSidePanelOpen, setIsSidePanelOpen] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(true);

  const toggleSidePanel = () => {
    setIsSidePanelOpen(!isSidePanelOpen);
  };

  return (
    <>
      <NavBar onMenuClick={toggleSidePanel} themeMode={themeMode} onThemeToggle={onThemeToggle} />
      <div className={`${styles.contentRow} ${isSidebarCollapsed ? styles.sidebarCollapsed : ""} ${themeMode === "dark" ? styles.dark : ""}`}>
        <div className={styles.sidebarSpacer} />
        <main className={`${styles.mainContent} ${isSidebarCollapsed ? styles.mainContentCollapsed : ""} ${themeMode === "dark" ? styles.mainContentDark : ""}`}>
          <Outlet />
        </main>
        <SidePanel
          open={isSidePanelOpen}
          onClose={toggleSidePanel}
          collapsed={isSidebarCollapsed}
          onExpand={() => setIsSidebarCollapsed(false)}
          onCollapse={() => setIsSidebarCollapsed(true)}
          themeMode={themeMode}
        />
        <SignUpDialog />
        <SigninDialog />
      </div>
    </>
  );
};

export default MainLayout;

